module.exports = __webpack_public_path__ + "img/clipboard-list-check.689a1113.svg";